/**
 * @readonly
 * @enum {string}
 */
const InboxMessageAttribute = Object.freeze({
    NAME: 'name',
    VALUE: 'value'
})

export { InboxMessageAttribute }
